import { useRef } from 'react';
import { Toast } from 'primereact/toast';
import { extractErrorMessage } from '../utils/error-handler';

/** Toast plus the two helpers every tab needs. `message` is what the API wants shown. */
export function useToastApi() {
  const ref = useRef<Toast>(null);
  const toast = <Toast ref={ref} position="top-right" />;
  const ok = (detail: string) =>
    ref.current?.show({ severity: 'success', summary: 'Done', detail, life: 3000 });
  const fail = (e: unknown) => {
    ref.current?.show({
      severity: 'error',
      summary: 'Failed',
      // Through the shared extractor, which knows every shape the API answers
      // in. Reading only the envelope's `message` meant a 422 — whose reason is
      // under `error.details`, or in FastAPI's own `detail` list — showed
      // "Request failed" and nothing else: the one failure that always has a
      // precise, actionable reason was the one that never showed it.
      detail: extractErrorMessage(e, 'Request failed'),
      life: 6000,
    });
  };
  return { toast, ok, fail };
}
